'use client';

import React from 'react';
import '../styles/LoadingSkeleton.css';

export const CardSkeleton = () => (
  <div className="skeleton-card">
    <div className="skeleton-line skeleton-title"></div>
    <div className="skeleton-line skeleton-amount"></div>
    <div className="skeleton-line skeleton-subtitle"></div>
  </div>
);

export const TableSkeleton = ({ rows = 5, columns = 6 }) => (
  <div className="skeleton-table">
    <div className="skeleton-table-header">
      {Array.from({ length: columns }).map((_, i) => (
        <div key={i} className="skeleton-line skeleton-header"></div>
      ))}
    </div>
    {Array.from({ length: rows }).map((_, rowIndex) => (
      <div key={rowIndex} className="skeleton-table-row">
        {Array.from({ length: columns }).map((_, colIndex) => (
          <div key={colIndex} className="skeleton-line skeleton-cell"></div>
        ))}
      </div>
    ))}
  </div>
);

export const FormSkeleton = () => (
  <div className="skeleton-form">
    {Array.from({ length: 6 }).map((_, i) => (
      <div key={i} className="skeleton-form-group">
        <div className="skeleton-line skeleton-label"></div>
        <div className="skeleton-line skeleton-input"></div>
      </div>
    ))}
  </div>
);

const LoadingSkeleton = {
  Card: CardSkeleton,
  Table: TableSkeleton,
  Form: FormSkeleton
};

export default LoadingSkeleton;
